module.exports = __webpack_public_path__ + "static/media/04.2e700fc1.png";